module.exports = __webpack_public_path__ + "static/img/09.7498818.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/09.png
// module id = 4LLf
// module chunks = 2